// import headerBg2 from "@/assets/images/active/sakura/shake/header/header_bg2.png";
// import officeBtn from "@/assets/images/active/sakura/shake/header/btn_05.png";
// import loginBtn from "@/assets/images/active/sakura/shake/header/btn_06.png";
// import accountBtn from "@/assets/images/active/sakura/shake/header/btn_07.png";
// import logoutBtn from "@/assets/images/active/sakura/shake/header/btn_10.png";

export const headerConfig = {
  not_logged_in: {
    background_image: "https://download4.qcplay.com/h5-images/active/sakura/shake/header/header_bg2.png",
    style: ""
  },
  logged_in: {
    background_image: "https://download4.qcplay.com/h5-images/active/sakura/shake/header/header_bg2.png",
    main_title_color: "#fff",
    sub_title_color: "#fff",
    tips_color: "#fff",
    game_name: "魔卡少女樱：回忆钥匙"
  },
  operation_btn: {
    office_website: {
      width: "",
      height: "",
      background_image: "",
      img: "https://download4.qcplay.com/h5-images/active/sakura/shake/header/btn_05.png",
      style: "",
      link: "https://sakura.qingcijoy.com/official/index.html"
    },
    login: {
      width: "",
      height: "",
      background_image: "",
      img: "https://download4.qcplay.com/h5-images/active/sakura/shake/header/btn_06.png",
      style: ""
    },
    change_account: {
      width: "",
      height: "",
      background_image: "",
      img: "https://download4.qcplay.com/h5-images/active/sakura/shake/header/btn_07.png",
      style: ""
    },
    join_active: {
      width: "",
      height: "",
      background_image: "",
      img: "",
      style: ""
    },
    logout: {
      width: "",
      height: "",
      img: "https://download4.qcplay.com/h5-images/active/sakura/shake/header/btn_10.png",
      style: ""
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/sakura/shake/headerConfig.js